/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MonitoredCertificateDtoTimeToExpirationChronology,
    MonitoredCertificateDtoTimeToExpirationChronologyFromJSON,
    MonitoredCertificateDtoTimeToExpirationChronologyFromJSONTyped,
    MonitoredCertificateDtoTimeToExpirationChronologyToJSON,
} from './MonitoredCertificateDtoTimeToExpirationChronology';
import {
    MonitoredCertificateDtoTimeToExpirationUnits,
    MonitoredCertificateDtoTimeToExpirationUnitsFromJSON,
    MonitoredCertificateDtoTimeToExpirationUnitsFromJSONTyped,
    MonitoredCertificateDtoTimeToExpirationUnitsToJSON,
} from './MonitoredCertificateDtoTimeToExpirationUnits';

/**
 * 
 * @export
 * @interface MonitoredCertificateDtoTimeToExpiration
 */
export interface MonitoredCertificateDtoTimeToExpiration {
    /**
     * 
     * @type {number}
     * @memberof MonitoredCertificateDtoTimeToExpiration
     */
    years?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitoredCertificateDtoTimeToExpiration
     */
    months?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitoredCertificateDtoTimeToExpiration
     */
    days?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MonitoredCertificateDtoTimeToExpiration
     */
    negative?: boolean;
    /**
     * 
     * @type {Array<MonitoredCertificateDtoTimeToExpirationUnits>}
     * @memberof MonitoredCertificateDtoTimeToExpiration
     */
    units?: Array<MonitoredCertificateDtoTimeToExpirationUnits>;
    /**
     * 
     * @type {boolean}
     * @memberof MonitoredCertificateDtoTimeToExpiration
     */
    zero?: boolean;
    /**
     * 
     * @type {MonitoredCertificateDtoTimeToExpirationChronology}
     * @memberof MonitoredCertificateDtoTimeToExpiration
     */
    chronology?: MonitoredCertificateDtoTimeToExpirationChronology;
}

export function MonitoredCertificateDtoTimeToExpirationFromJSON(json: any): MonitoredCertificateDtoTimeToExpiration {
    return MonitoredCertificateDtoTimeToExpirationFromJSONTyped(json, false);
}

export function MonitoredCertificateDtoTimeToExpirationFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitoredCertificateDtoTimeToExpiration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'years': !exists(json, 'years') ? undefined : json['years'],
        'months': !exists(json, 'months') ? undefined : json['months'],
        'days': !exists(json, 'days') ? undefined : json['days'],
        'negative': !exists(json, 'negative') ? undefined : json['negative'],
        'units': !exists(json, 'units') ? undefined : ((json['units'] as Array<any>).map(MonitoredCertificateDtoTimeToExpirationUnitsFromJSON)),
        'zero': !exists(json, 'zero') ? undefined : json['zero'],
        'chronology': !exists(json, 'chronology') ? undefined : MonitoredCertificateDtoTimeToExpirationChronologyFromJSON(json['chronology']),
    };
}

export function MonitoredCertificateDtoTimeToExpirationToJSON(value?: MonitoredCertificateDtoTimeToExpiration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'years': value.years,
        'months': value.months,
        'days': value.days,
        'negative': value.negative,
        'units': value.units === undefined ? undefined : ((value.units as Array<any>).map(MonitoredCertificateDtoTimeToExpirationUnitsToJSON)),
        'zero': value.zero,
        'chronology': MonitoredCertificateDtoTimeToExpirationChronologyToJSON(value.chronology),
    };
}

